export default {"src":"/_next/static/media/resign.f668b04c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};